// extracted by mini-css-extract-plugin
export var grid = "navigation-menu-desktop-dr-module--grid--f2df8";
export var gridBannerOptions = "navigation-menu-desktop-dr-module--grid-banner-options--c5e6b";
export var gridBannerWide = "navigation-menu-desktop-dr-module--grid-banner-wide--f5bf9";
export var gridHidden = "navigation-menu-desktop-dr-module--grid-hidden--e8b07";
export var gridItemOptions = "navigation-menu-desktop-dr-module--grid-item-options--31fc6";
export var gridRight = "navigation-menu-desktop-dr-module--grid-right--93139";
export var navigationMenuDesktop = "navigation-menu-desktop-dr-module--navigation-menu-desktop--ca9c1";